import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zhTW from './zh-TW.json'
import en from './en.json'

const LANG_STORAGE_KEY = 'tg_game_lang'

function detectLanguage(): string {
  if (import.meta.env.VITE_DEMO_MODE === 'true') {
    try {
      const query = new URLSearchParams(window.location.search)
      const hosts = ['https://lumechart.com', 'https://www.lumechart.com', 'http://127.0.0.1:4321', 'http://localhost:4321']
      if (window.parent !== window && hosts.includes(query.get('lc_host') ?? '')) {
        const locale = query.get('lc_locale')
        if (locale === 'en') return 'en'
        // There is no Simplified Chinese resource: explicitly use Traditional Chinese.
        if (locale === 'zh-Hant' || locale === 'zh-Hans') return 'zh-TW'
      }
    } catch {
      /* Keep the existing standalone locale detection if embedding metadata is unavailable. */
    }
  }
  try {
    const stored = localStorage.getItem(LANG_STORAGE_KEY)
    if (stored === 'en' || stored === 'zh-TW') return stored
  } catch {
    /* ignore */
  }
  const nav = (typeof navigator !== 'undefined' ? navigator.language : '') || ''
  if (nav.toLowerCase().startsWith('en')) return 'en'
  return 'zh-TW'
}

void i18n.use(initReactI18next).init({
  resources: {
    'zh-TW': { translation: zhTW },
    en: { translation: en },
  },
  lng: detectLanguage(),
  fallbackLng: 'zh-TW',
  supportedLngs: ['zh-TW', 'en'],
  interpolation: { escapeValue: false },
})

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language?.startsWith('en') ? 'en' : 'zh-Hant'
}

export default i18n
